const SimpleOrder = {
    extenstionsWhitelist: [],
    isFetching: false
}

const initialState = {
    SimpleOrder,
}

export default initialState;
